/**
 * TOON Service
 * Converts JSON data to TOON format for efficient data representation
 */

import { encode } from "@toon-format/toon";

export const toonService = {
  /**
   * Convert JSON data to TOON format
   */
  jsonToToon(data: any): string {
    try {
      return encode(data);
    } catch (error) {
      console.error("Error converting JSON to TOON:", error);
      // Fallback to JSON string if TOON conversion fails
      return JSON.stringify(data, null, 2);
    }
  },
};
